import "./sb.css";
import m from "mithril";


let cb = () => {
    let originalValue = null;
    var preselectedData = null;
    let curValue = null;

    function pushoutput(v) {
        if ($(v.dom).hasClass("select2-hidden-accessible")) {
            if (v.attrs.onchange) {
                let selected = $(v.dom).select2('data');
                let vals = selected.map(d => d.id).join();
                let texts = selected.map((d) => d.text).join();
                // console.log({ selected, vals, texts });
                if (vals != originalValue) {
                  curValue = vals;

                  //$("#mySelect2").val("1"); // Select the option with a value of '1'
                //   $(v.dom).trigger("change"); // Notify any JS components that the value changed

                  v.attrs.onchange(vals, texts);
                }
            }
        }
    }

    return {
        onremove: v => {
            if ($(v.dom).hasClass("select2-hidden-accessible")) {
                $(v.dom).select2('destroy');
            }
        },
        oncreate: v => {
            if (!preselectedData) {
                var values = (v.attrs.value || "").split(',');
                var texts = (v.attrs.text || "").split(',');

                preselectedData = values.filter(a => !!a).map((val, i) => {
                    return new Option(texts[i], val, true, true);
                });
            }

            $(v.dom).select2({
                width: '100%',
                multiple: v.attrs.multiple,
                closeOnSelect: !v.attrs.multiple,
                placeholder: "...",
                allowClear: true,
                ajax: {
                    delay: 250,
                    url: () => {
                        if (v.attrs.parentoptions)
                            return "/api.aspx/GetOptionsForMultiDropDowns";
                        else
                            return "/api.aspx/GetOptionData";
                    },
                    data: function (term) {
                        let finalData = JSON.stringify({
                            data: JSON.stringify({
                                q: term.term || '',
                                page_limit: 10,
                                parentoptions: v.attrs.parentoptions,
                                page: term.page || 1,
                                nf: v.attrs.nf
                            })
                        });
                        return finalData;
                    },
                    processResults: function (data) {
                        let r = JSON.parse(data.d);
                        return {
                            results: r.items,
                            pagination: {
                                more: r.morepages
                            }
                        };
                    },
                    type: "POST",
                    timeout: 120000,
                    contentType: "application/json; charset=utf-8", //"application/json; charset=utf-8",header('Content-type: application/json');
                    dataType: "json",
                    error: function (jqXHR, textStatus, errorThrown) {
                        if (!isUserAborted(jqXHR)) {
                            console.log("Ajax Error")
                            console.log('Error: ' + textStatus + ' ' + errorThrown);
                            console.log(jqXHR.responseText);
                        }
                    }
                }
            });

            if (preselectedData)
                $(v.dom).append(preselectedData).trigger('change');

            $(v.dom).on("select2:close", function (e) {
                pushoutput(v);
            });

            $(v.dom).on("select2:unselect", function (e) {
                pushoutput(v);
            });


        },
        view: v => {
            if (v.attrs.multiple)
                return m("select.td-select", {
                    size: 1,
                    multiple: "multiple",
                    disabled: v.attrs.disabled
                });
            else
                return m("select.td-select", {
                    size: 1,
                    disabled: v.attrs.disabled
                });
        },
        onupdate: v => {
            if (!v.attrs.value && curValue) {
                if ($(v.dom).hasClass("select2-hidden-accessible")) {
                    $(v.dom).val('').trigger('change');
                    curValue = null;
                    //console.log(v.attrs.parentoptions.index, "setting", v.attrs.value, "dom", v.dom);

                    // preselectedData = null;
                    // originalValue = null;
                    // if ($(v.dom).hasClass("select2-hidden-accessible"))
                    //     $(v.dom).val('').trigger('change');
                }
            }
        }
    }
};

export default cb;